/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReportListCreate = {
  readonly uuid: string
  /**
   * * `PENDING` - Pending
   * * `PREPARATION` - Preparation
   * * `RUNNING` - Running
   * * `SUCCEEDED` - Succeeded
   * * `FAILED` - Failed
   * * `CANCELLED` - Cancelled
   * * `PARTIALLY_SUCCEEDED` - Partially Succeeded
   */
  readonly status: ReportListCreate.status
  readonly created_at: string
  readonly created_by: string
  /**
   * * `DATASET` - Dataset
   * * `TRAINING_DATA` - Training data
   * * `PREDICTION` - Predictions
   * * `WORKFLOW_PREDICTION` - Workflow Prediction
   * * `MODEL_PREDICTION` - Model Prediction
   * * `SIMULATION` - Simulation
   */
  type: ReportListCreate.type
  /**
   * Should be in ISO format (YYYY-MM-DDTHH:mm:ss)
   */
  predictions_start_time?: string
  /**
   * Should be in ISO format (YYYY-MM-DDTHH:mm:ss)
   */
  predictions_end_time?: string
  readonly is_periodical: boolean
}
export namespace ReportListCreate {
  /**
   * * `PENDING` - Pending
   * * `PREPARATION` - Preparation
   * * `RUNNING` - Running
   * * `SUCCEEDED` - Succeeded
   * * `FAILED` - Failed
   * * `CANCELLED` - Cancelled
   * * `PARTIALLY_SUCCEEDED` - Partially Succeeded
   */
  export enum status {
    PENDING = "PENDING",
    PREPARATION = "PREPARATION",
    RUNNING = "RUNNING",
    SUCCEEDED = "SUCCEEDED",
    FAILED = "FAILED",
    CANCELLED = "CANCELLED",
    PARTIALLY_SUCCEEDED = "PARTIALLY_SUCCEEDED",
  }
  /**
   * * `DATASET` - Dataset
   * * `TRAINING_DATA` - Training data
   * * `PREDICTION` - Predictions
   * * `WORKFLOW_PREDICTION` - Workflow Prediction
   * * `MODEL_PREDICTION` - Model Prediction
   * * `SIMULATION` - Simulation
   */
  export enum type {
    DATASET = "DATASET",
    TRAINING_DATA = "TRAINING_DATA",
    PREDICTION = "PREDICTION",
    WORKFLOW_PREDICTION = "WORKFLOW_PREDICTION",
    MODEL_PREDICTION = "MODEL_PREDICTION",
    SIMULATION = "SIMULATION",
  }
}
